class Model {
  constructor(obj) {
    if (typeof obj === typeof {}) {
      const whitelistedPropertyKeys = this.getWhitelistedPropertyKeys();
      Object.keys(obj).forEach(
        k => {
          if (whitelistedPropertyKeys.indexOf(k) >= 0) {
            this[k] = obj[k];
          }
        }
      );
    }
  }

  getWhitelistedProperties() {
    return {};
  }

  getWhitelistedPropertyKeys() {
    return Object.keys(this.getWhitelistedProperties());
  }

  getDisplayPropertyNames() {
    const properties = this.getWhitelistedProperties();
    return this.getWhitelistedPropertyKeys().reduce(
        (obj, k) => {
          const property = properties[k];
          if (property.isUserDisplayable !== false) {
            obj[k] = property.name;
          }
          return obj;
        },
        {});
  }
}


export default Model;
